import React from 'react'
import { useTranslation } from 'react-i18next'
import { useApolloClient } from '@apollo/client'

import BPMTable from '../../components/BPMTable/BPMTable'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import formCreatorCreatorFactoryCreator from '../../components/BPMTable/FormCreatorFactory/FormCreatorCreatorFactoryCreator'
import BayphoneUserTableCreator from '../../tableDefinitions/Bayphone/BayphoneUserTableCreator'
import BayphoneUserFormCreator from '../../tableDefinitions/Bayphone/BayphoneUserFormCreator'

const BayphoneUser = (props) => {
    const { t } = useTranslation(['bayphone'])
    const client = useApolloClient()

    document.title = `${t('Bayphone User')} - BubbleBPM`

    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(BayphoneUserTableCreator.getId(), {tcFilters: {}})
    tableCreatorCreator.setClient(client)
    const tableCreator = tableCreatorCreator.getTableCreator('Bayphone Users')

    var formCreatorCreator = formCreatorCreatorFactoryCreator.getFormCreatorCreatorFromIdentifier(BayphoneUserFormCreator.getId(), null)
    const formCreator = formCreatorCreator.getFormCreator()

    return (
        <>
            <BPMTable
                TableCreator={tableCreator}
                FormCreator={formCreator}
                path={props.match.url}
            />
        </>
    )
}

export default BayphoneUser